<script lang="ts">
    import Divider from "../components/Divider.svelte";
    import Icon from "../components/Icon.svelte";
    import { messageInfo } from "../store.js";

    function abort() {
        messageInfo.reset();
    }
</script>

<main>
    <Divider>Reprise d'installation</Divider>
    <p>
        Nous avons détecté que vous n'avez pas terminé avec succès la validation
        précédente.
    </p>
    <p>
        Souhaitez vous reprendre l'installation pour le boîtier
        <b>{$messageInfo.imei}</b>
        ?
    </p>

    <div class="text-end">
        <button type="submit" class="btn btn-danger" on:click={abort}>
            Non
            <Icon icon="arrow-repeat" />
        </button>
        <button type="submit" class="btn btn-primary">
            Oui
            <Icon icon="chevron-double-right" />
        </button>
    </div>
</main>
